/**
 * Dynamic API URL configuration
 * Uses environment variable or derives from current domain
 */
const getAPIBaseURL = () => {
  // Use environment variable if set (for build-time configuration)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Fall back to dynamic URL based on current domain
  const protocol = window.location.protocol; // https: or http:
  const hostname = window.location.hostname; // localhost or domain.com
  
  // In development, backend runs on port 4000
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:4000/api`;
  }
  
  // In production, API is on same domain
  return `${protocol}//${hostname}/api`;
};

export const API_BASE_URL = getAPIBaseURL();

export default API_BASE_URL;
